export default __webpack_public_path__ + "8c8e7169c9b79bf98ad7f1ebbe24e554.svg";